export default __webpack_public_path__ + "static/media/Home_03.e44998de.png";